module.exports = __webpack_public_path__ + "static/media/DSC_0038.d05fa940.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0038.jpg
// module id = 680
// module chunks = 0